import React, { PureComponent } from "react";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import ConfirmEmail from "./ConfirmEmail";
import ChangePassword from "./ChangePassword";
// import TwoFactor from "./Enable2FA";

class RegisterForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      fields: {
        companyUUID: "",
        email: "",
        firstName: "",
        lastName: "",
        companyName: "",
        industry: "",
        country: "",
        password: "",
        telephone: "",
        role: "",
        pilot: "",
        environment: [],
      },
      showPassword: false,
    };

    this.showPassword = this.showPassword.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({
      fields: {
        ...this.state.fields,
        [name]: value,
      },
    });
  }

  changeSelectValue(name, value) {
    this.setState({
      fields: {
        ...this.state.fields,
        [name]: value,
      },
    });
  }

  showPassword(e) {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword,
    });
  }

  moveToNext() {
    this.setState({ step: this.state.step + 1 });
  }

  goBack() {
    this.setState({ step: this.state.step - 1 });
  }

  onSubmit() {
    this.props.history.push("/confirmation");
  }

  componentDidMount() {
    const _params = queryString.parse(this.props.location.search);
    const _companyUUID = this.props.match.params.uuid;
    const _firstName = _params.firstName;
    const _lastName = _params.lastName;
    const _companyName = _params.companyName;
    const _email = _params.email;
    const _environment = Array.isArray(_params.env)
      ? _params.env
      : _params.env.split();

    this.setState({
      fields: {
        companyUUID: _companyUUID,
        firstName: _firstName,
        lastName: _lastName,
        companyName: _companyName,
        email: _email,
        environment: _environment,
      },
    });
  }

  render() {
    const { step } = this.state;

    return (
      <div className="account" id="setup-account">
        <div className="centered">
          <div className="account__card">
            <div>
              {step === 0 ? (
                <ConfirmEmail
                  companyName={this.state.fields.companyName}
                  email={this.state.fields.email}
                  handleChange={this.handleChange.bind(this)}
                  next={this.moveToNext.bind(this)}
                />
              ) : step === 1 ? (
                <ChangePassword
                  handleChange={this.handleChange.bind(this)}
                  changeSelect={this.changeSelectValue.bind(this)}
                  back={this.goBack.bind(this)}
                  next={this.moveToNext.bind(this)}
                  fields={this.state.fields}
                />
              ) : null }
              {/* ) : step === 2 ? (
                <TwoFactor
                  companyName={this.state.fields.companyName}
                  email={this.state.fields.email}
                  handleChange={this.handleChange.bind(this)}
                  back={this.goBack.bind(this)}
                  next={this.moveToNext.bind(this)}
                  fields={this.state.fields}
                />
              ) : null} */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(RegisterForm);



// WEBPACK FOOTER //
// ./src/pages/account/register/components/Setup.js